import * as React from 'react';
import history from "../history";
import {ConnectedRouter} from "react-router-redux";
import {Route, Switch} from "react-router-dom";
import HouseListController from "../containers/HouseListController";
import HouseDetailController from "../containers/HouseDetailController";
import HouseCreateController from "../containers/HouseCreateController";
import {ROUTE_HOUSE, ROUTE_HOUSE_CREATE, ROUTE_HOUSE_ID} from "./index";

export default () => (
	<ConnectedRouter history={history}>
		<Switch>
			<Route exact path={ROUTE_HOUSE} component={HouseListController}/>
			<Route exact path={ROUTE_HOUSE_CREATE} component={HouseCreateController} />
			<Route path={ROUTE_HOUSE_ID} component={HouseDetailController} />
		</Switch>
	</ConnectedRouter>
);


// WEBPACK FOOTER //
// ./src/routes/HouseRoutes.js